export default __webpack_public_path__ + "static/media/1upLogo.09249cdd.png";